import { FaAngleDown } from 'react-icons/fa';
import { Trans, useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import React, { memo, useContext, useState } from 'react';
import * as styles from './Settings.module.css';
import { languages } from '../../../../i18n';
import { useDispatch } from '../../../../contexts/ResumeContext';
import Button from '../../../shared/Button';
import Heading from '../../../shared/Heading';
import Input from '../../../shared/Input';
import SettingsContext from '../../../../contexts/SettingsContext';
import UserContext from '../../../../contexts/UserContext';
import themeConfig from '../../../../data/themeConfig';

const Settings = ({ id }) => {
  const { t } = useTranslation();

  const [deleteText, setDeleteText] = useState(
    t('builder.settings.dangerZone.button'),
  );
  const [isDeleteAccountInProgress, setDeleteAccountInProgress] =
    useState(false);

  const dispatch = useDispatch();
  const { deleteAccount } = useContext(UserContext);
  const { theme, setTheme, language, setLanguage } =
    useContext(SettingsContext);

  const handleChangeTheme = (e) => {
    setTheme(e.target.value);
  };

  const handleChangeLanguage = (e) => {
    const lang = e.target.value;
    setLanguage(lang);
    dispatch({ type: 'change_language', payload: lang });
  };

  const handleDeleteAccount = async () => {
    if (deleteText === t('builder.settings.dangerZone.button')) {
      setDeleteText(t('shared.buttons.confirmation'));
      return;
    }

    setDeleteAccountInProgress(true);

    try {
      await deleteAccount();
    } catch (error) {
      toast.error('An error occurred deleting your account.');
      setDeleteAccountInProgress(false);
      setDeleteText(t('builder.settings.dangerZone.button'));
    }
  };

  return (
    <section>
      <Heading id={id} />

      <Input
        label={t('builder.settings.theme')}
        type="dropdown"
        options={Object.keys(themeConfig)}
        value={theme}
        onChange={handleChangeTheme}
      />

      <label>
        <span>{t('builder.settings.language')}</span>
        <div className="relative grid items-center">
          <select onChange={handleChangeLanguage} value={language}>
            {languages.map((x) => (
              <option key={x.code} value={x.code}>
                {x.name}
              </option>
            ))}
          </select>

          <FaAngleDown
            size="16px"
            className="absolute right-0 opacity-50 hover:opacity-75 mx-4"
          />
        </div>
      </label>
    </section>
  );
};

export default memo(Settings);
